export default "__VITE_ASSET__2a56dd23__"